export const routeHashes = {
    quiz: "#quiz",
    video: "#video",
    eBook: "#ebook"
};
